import { connect } from 'react-redux';
import FlatBallasted from './FlatBallasted';

import { getAnnualResults } from '../../selectors';


const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    firstName: state.contactUI.firstName,
    systemSize: state.solar.systemSize,
});

const combinedActions = { };

export default connect(mapStateToProps, combinedActions)(FlatBallasted);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/FlatBallasted/index.js